import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

import { FormGroup } from '@angular/forms';
import { AlertComponent } from './alert/alert.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ProgressSpinnerComponent } from './progress-spinner/progress-spinner.component';
import { UserDetails } from './model/user-details';
import { InvitationService } from '../service/invitation.service';

export class BioVerifyComponent implements OnDestroy {

    ngUnsubscribe: Subject<void> = new Subject<void>();
    spinnerDialog: MatDialogRef<ProgressSpinnerComponent>;

    ngOnDestroy(): void {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }

    usersHomePath(userDetails: UserDetails): string {
      if (userDetails.userType === 'unknown') {
        return '/securehome/register';
      } else if (userDetails.userType === 'full-combined') {
        return '/securehome/verifications';
      } else if (userDetails.userType === 'full' && userDetails.preInvites) {
        return '/securehome/invite-links';
      } else {
        return '/securehome';
      }
    }

    showErrors(form: FormGroup, formErrors: Object, validationMessages: Object, ignoreDirty: Boolean) {
      if (!form) { return; }

      for (const field of Object.keys(formErrors)) {
        // clear previous error message (if any)
        formErrors[field] = '';
        const control = form.get(field);

        if (control && (control.dirty || ignoreDirty) && !control.valid) {
          const messages = validationMessages[field];
          for (const key of Object.keys(control.errors)) {
            formErrors[field] += messages[key] + ' ';
          }
        }
      }
    }

    showAlert(dialog: MatDialog, title: string, message: string, width?: string) {
      const dialogRef = dialog.open(AlertComponent, {
        width: width || '320px',
        data: { title: title,  message: message }
      });

      dialogRef.afterClosed().subscribe(result => {
        console.log('The dialog was closed');
      });

    }

    showOptionsDialog(dialog: MatDialog, title: string, message: string, button1: string, button2: string, onClose?: (buttonPressed: string) => void, width?: string) {
      const dialogRef = dialog.open(AlertComponent, {
        width: width || '320px',
        data: {
          title: title,
          message: message,
          button1: button1,
          button2: button2,
        }
      });

      dialogRef.afterClosed().subscribe(result => {
        console.log('The dialog was closed');
        if (onClose) {
          onClose(result);
        }
      });
    }


    showProgressSpinner(dialog: MatDialog) {
      this.spinnerDialog = dialog.open(ProgressSpinnerComponent, {
        width: '120px',
      });
    }

    hideProgressSpinner() {
      if (this.spinnerDialog) {
        this.spinnerDialog.close();
      }
    }

  async forwardToBiometric(document: Document, invitationService: InvitationService, invitationId: string, captureUrl: string, dialog: MatDialog) {
    if (captureUrl !== 'startOnDemand') {
      document.location.href = captureUrl;
      return;
    }
    this.showProgressSpinner(dialog);
    try {
      const startTransactionResponse = await invitationService.startBiometricTransaction(invitationId);
      const newCaptureUrl = startTransactionResponse.captureUrl as string;
      this.hideProgressSpinner();
      document.location.href = newCaptureUrl;
    } catch (err) {
      console.log(`Error ${err.message}`);
      this.hideProgressSpinner();
      this.showAlert(dialog, 'PROBLEM', `Failed to start biometric capture process. Press close your browser tab or window and tap on the link again to retry from the beginning.`);
    };
  }

}
